'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _universalCookie = require('universal-cookie');

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _en = require('../intl/en');

var _en2 = _interopRequireDefault(_en);

var _flattenMessages = require('../utils/flattenMessages');

var _flattenMessages2 = _interopRequireDefault(_flattenMessages);

var _pagination = require('../utils/pagination');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookie = new _universalCookie2.default();

var DEFAULT_ITEMS_TO_SHOW = 24;

var getInitialData = function getInitialData() {
    var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { cookies: [], headers: [], hostname: '', url: '' };
    var whiteLabelInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // check the cookie for a valid token
    var referrer = req.headers.referer || '';
    var touchDate = new Date().getTime();
    var disableModalForTesting = req.url.includes('hideForTesting') || req.url.includes('/console/');

    var whiteLabel = {
        hostname: req.hostname,
        isWhiteLabel: false,
        logo: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
        sellerId: 0
    };

    var pageSize = (0, _pagination.getPageSizeFromCookie)(req.cookies['pagination-page-size']) || (0, _pagination.getPageSizeFromCookie)(cookie.get('pagination-page-size')) || DEFAULT_ITEMS_TO_SHOW;

    if (whiteLabelInfo) {
        var sellerName = whiteLabelInfo.name,
            sellerId = whiteLabelInfo.sellerId,
            website = whiteLabelInfo.website,
            logoId = whiteLabelInfo.logoId;

        var siteNameMatch = (website || '').match(/^(?:https?:\/\/)?(?:[w]{3}\.)?(.*)$/);
        var siteName = siteNameMatch && siteNameMatch[1].length > 0 ? siteNameMatch[1].replace(/\/+$/, '') : '';

        whiteLabel = {
            hostname: req.hostname,
            isWhiteLabel: true,
            logo: !logoId || logoId === '' ? null : 'https://images.liveauctioneers.com/houses/logos/lg/' + logoId + '_large.jpg?auto=webp&format=pjpg',
            name: sellerName,
            sellerId: sellerId,
            siteName: siteName,
            siteUrl: website || ''
        };
    }

    return {
        config: _config2.default,
        intl: {
            defaultLocale: 'en',
            locale: 'en',
            messages: (0, _flattenMessages2.default)(_en2.default)
        },
        ui: {
            analytics: {
                referrer: referrer,
                touchDate: touchDate
            },
            autoPopModal: {
                dateLastShown: '',
                disableModalForTesting: disableModalForTesting,
                hasLoggedInBefore: false
            },
            browser: {
                deviceType: '',
                microsoftBrowser: false,
                mobile: '',
                name: ''
            },
            pagination: {
                pageSize: pageSize
            }
        },
        user: {
            user: { userData: {} }
        },
        whiteLabel: whiteLabel
    };
};

exports.default = getInitialData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/initialData.js
// module id = t5WM
// module chunks = 60